import React from 'react';
import { Stack } from '@mui/material';
import { ArrowBackOutlined, ArrowForwardOutlined } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import Img from './images/Deltek_Replicon.logo.svg';

const useStyles = makeStyles((theme) => ({
  stack: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: theme.spacing(2)
  },
  image: {
    height: theme.spacing(12.5),
    width: theme.spacing(18.75)
  },
  arrowIconBack: {
    width: theme.spacing(2.25),
    height: theme.spacing(2.25)
  },
  arrowIconForward: {
    width: theme.spacing(2),
    height: theme.spacing(2)
  },
  containerCol: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

type DialogHeaderProps = {
  shortName: string | undefined;
};
export const DialogHeaderContext: React.FC<DialogHeaderProps> = ({
  shortName
}: DialogHeaderProps) => {
  const classes = useStyles();
  return (
    <Stack className={classes.stack}>
      <img
        src={Img}
        alt="Deltek Replicon Logo"
        className={classes.image}
        data-testid="render-deltek-replicon-logo"
      />
      <div
        className={classes.containerCol}
        data-testid="check-forward/back-icons"
      >
        <ArrowBackOutlined className={classes.arrowIconForward} />
        <ArrowForwardOutlined className={classes.arrowIconBack} />
      </div>
      <img
        src={`logos/${shortName}.logo.svg`}
        alt={`${shortName} Logo`}
        className={classes.image}
        data-testid={`render-${shortName} Logo`}
      />
    </Stack>
  );
};
